(() => {
  const init = () => {
    const root = document.querySelector('[data-kw-policy]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const documentBody = root.querySelector('.shopify-policy__body');
    const toc = root.querySelector('[data-policy-toc]');
    const sidebar = root.querySelector('[data-policy-sidebar]');
    const details = root.querySelector('[data-policy-contents]');
    if (!documentBody || !toc || !sidebar || !details) return;
    const firstParagraph = documentBody.querySelector('p');
    if (firstParagraph) firstParagraph.classList.add('kw-policy-updated');
    const headings = [...documentBody.querySelectorAll('h2')];
    if (!headings.length) return;
    const links = headings.map((heading, index) => {
      if (!heading.id) heading.id = 'policy-section-' + (index + 1);
      const link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent.trim();
      toc.append(link);
      return link;
    });
    const desktop = matchMedia('(min-width: 901px)');
    const syncDetails = () => {
      details.open = desktop.matches;
      details.querySelector('summary').tabIndex = desktop.matches ? -1 : 0;
    };
    desktop.addEventListener('change', syncDetails);
    syncDetails();
    sidebar.hidden = false;
    toc.addEventListener('click', event => {
      const link = event.target.closest('a');
      if (!link) return;
      const heading = document.getElementById(link.hash.slice(1));
      if (!heading) return;
      if (!desktop.matches) details.open = false;
      requestAnimationFrame(() => {
        heading.setAttribute('tabindex', '-1');
        heading.focus({preventScroll: true});
        heading.scrollIntoView({block: 'start'});
      });
    });
    let queued = false;
    const markCurrent = () => {
      let current = -1;
      headings.forEach((heading, index) => {
        if (heading.getBoundingClientRect().top <= 160) current = index;
      });
      links.forEach((link, index) => {
        if (index === current) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
      queued = false;
    };
    addEventListener('scroll', () => {
      if (!queued) { queued = true; requestAnimationFrame(markCurrent); }
    }, {passive: true});
    markCurrent();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
